import {createLazyFileRoute} from '@tanstack/react-router'

import Stores from '@/views/Stores/Stores'

export const Route = createLazyFileRoute('/stores/')({
  component: Stores,
})
